import classcat from "classcat";
import React from "react";

import css from "./CheckoutFormSectionTitle.module.css";

type Props = {
  title: string;
};

const CheckoutFormSectionTitle = ({ title }: Props) => {
  return (
    <div className={classcat([css.container, "text-headline-3xl"])}>
      <strong>{title}</strong>
    </div>
  );
};

export default CheckoutFormSectionTitle;
